class CartUpsell extends HTMLElement {
  constructor() {
    super();

    // Stops Dawn's cart-drawer-items from treating the variant select as a quantity change.
    this.addEventListener('change', (event) => {
      event.stopPropagation();
      const option = event.target.selectedOptions && event.target.selectedOptions[0];
      const price = event.target.closest('.cart-upsell__card').querySelector('[data-upsell-price]');
      if (option && option.dataset.price && price) price.textContent = option.dataset.price;
    });

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-upsell-add]');
      if (button) this.addToCart(button);
    });
  }

  addToCart(button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    const card = button.closest('.cart-upsell__card');
    const error = card.querySelector('.cart-upsell__error');
    const cartDrawer = document.querySelector('cart-drawer');
    const variantId = card.querySelector('[name="id"]').value;

    if (!variantId) {
      error.textContent = 'Choisis une option avant d\'ajouter.';
      error.hidden = false;
      card.querySelector('select')?.focus();
      return;
    }

    const label = button.querySelector('span');
    const resetButton = () => {
      button.removeAttribute('aria-disabled');
      label.textContent = 'Ajouter';
    };
    button.setAttribute('aria-disabled', 'true');
    label.textContent = 'Ajout…';
    error.hidden = true;

    fetch(`${routes.cart_add_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          error.textContent = response.status === 422 && response.description ? response.description : window.cartStrings.error;
          error.hidden = false;
          resetButton();
          return;
        }
        cartDrawer.renderContents(response);
      })
      .catch(() => {
        error.textContent = window.cartStrings.error;
        error.hidden = false;
        resetButton();
      });
  }
}

customElements.define('cart-upsell', CartUpsell);

// A cart offer is only valid next to a regular item: drop orphaned offers.
class CartOfferGuard extends HTMLElement {
  connectedCallback() {
    // On page load this script can run before Dawn's cart-drawer.js.
    customElements.whenDefined('cart-drawer').then(() => this.removeOffers());
  }

  removeOffers() {
    const cartDrawer = document.querySelector('cart-drawer');
    const updates = Object.fromEntries(this.dataset.keys.split(',').map((key) => [key, 0]));

    fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        updates,
        sections: cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      })
    })
      .then((response) => response.json())
      .then((state) => {
        cartDrawer.classList.toggle('is-empty', state.item_count === 0);
        cartDrawer.getSectionsToRender().forEach((section) => {
          const element = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (element) element.innerHTML = cartDrawer.getSectionInnerHTML(state.sections[section.id], section.selector);
        });
      });
  }
}

customElements.define('cart-offer-guard', CartOfferGuard);
